/**
 * Brinde por valor mínimo no carrinho.
 *
 * O snippets/cart-brinde.liquid renderiza um [data-cart-brinde] dentro do corpo
 * do carrinho com o estado já decidido pelo Liquid (bateu o mínimo? qual a linha
 * do brinde? sobrou alguma linha de brinde inválida?). Aqui só se acerta o
 * carrinho com esse estado, uma mudança por vez:
 *
 *   sobra de brinde        → remove a linha
 *   bateu o mínimo sem brinde → adiciona o brinde com a propriedade _brinde
 *   brinde com qtd ≠ 1     → volta para 1
 *
 * Cada mudança pede as seções do carrinho junto e emite o cartUpdate do tema;
 * o MCartItems re-renderiza e dispara cart:updated, que roda a conferência de
 * novo até não sobrar nada a fazer.
 */
(function () {
  if (window.LuckauCartBrinde) return;
  window.LuckauCartBrinde = true;

  const PROP_KEY = '_brinde';
  // Trava contra laço: se a mesma mudança deu certo e o carrinho voltou pedindo
  // ela de novo, algo de fora está desfazendo; para em vez de insistir.
  const MAX_REPEATS = 1;

  let busy = false;
  let lastAction = '';
  let repeats = 0;

  function sectionsToBundle() {
    const sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
    );
    return sections;
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections: sectionsToBundle() }),
    }).then((response) => {
      if (!response.ok) throw new Error(`${url} ${response.status}`);
      return response.json();
    });
  }

  function changeLine(key, quantity) {
    return post(`${window.Shopify.routes.root}cart/change.js`, { id: key, quantity });
  }

  function addGift(variantId) {
    return post(`${window.Shopify.routes.root}cart/add.js`, {
      items: [{ id: variantId, quantity: 1, properties: { [PROP_KEY]: 'true' } }],
    });
  }

  function nextAction(el) {
    const { variantId, eligible, lineKey, lineQuantity, strayKey } = el.dataset;

    if (strayKey) return { id: `remove:${strayKey}`, run: () => changeLine(strayKey, 0) };
    if (eligible !== 'true') return null;
    if (!lineKey) return variantId ? { id: `add:${variantId}`, run: () => addGift(Number(variantId)) } : null;
    if (Number(lineQuantity) !== 1) return { id: `fix:${lineKey}`, run: () => changeLine(lineKey, 1) };
    return null;
  }

  function reconcile() {
    if (busy) return;
    const el = document.querySelector('[data-cart-brinde]');
    if (!el) return;

    const action = nextAction(el);
    if (!action) {
      lastAction = '';
      repeats = 0;
      return;
    }

    repeats = action.id === lastAction ? repeats + 1 : 1;
    lastAction = action.id;
    if (repeats > MAX_REPEATS) return;

    busy = true;
    action
      .run()
      .then((response) => {
        busy = false;
        window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { cart: response });
      })
      .catch((error) => {
        busy = false;
        // Falha não conta como tentativa: a próxima mudança no carrinho tenta de novo.
        lastAction = '';
        console.warn('[brinde]', error);
      });
  }

  document.addEventListener('cart:updated', reconcile);

  // O cart:refresh troca o HTML sem disparar cart:updated; observar o corpo do
  // carrinho pega essa e qualquer outra re-renderização.
  ['MinimogCartDrawerBody', 'MinimogCartBody'].forEach((id) => {
    const body = document.getElementById(id);
    if (body) new MutationObserver(() => reconcile()).observe(body, { childList: true });
  });

  reconcile();
})();
